<template>
  <div class="row">
    <div :class="labelClasses">
      <slot name="label"></slot>
    </div>
    <div :class="valueClasses">
      <slot name="value"></slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      labelClasses: {
        type: String,
        default: 'col-4 col-xl-3 text-muted'
      },
      valueClasses: {
        type: String,
        default: 'col-8 col-xl-9'
      }
    }
  }
</script>
